export default __webpack_public_path__ + "bb74404f95774801643631646e10a6b3.png";